import { Button, CheckboxFormField, Form, IFormRender, IFormValidation } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import HeaderText from 'containers/settings/components/HeaderText/HeaderText';
import { useRef } from 'react';
import { t } from 'utils/localize';

export interface ISingleCheckFieldFormProps {
  title: string;
  initialValue?: boolean;
  subtitle?: string;
  onSubmit: (value: boolean) => void;
  validations?: Array<IFormValidation<boolean>>;
  className?: ClassName;
}

interface IFormData {
  key: boolean;
}

const SingleCheckFieldForm = ({
  title,
  subtitle,
  initialValue,
  validations,
  className,
  onSubmit,
}: ISingleCheckFieldFormProps) => {
  const formData = useRef({ key: initialValue ?? false });

  function renderFormFields(form: IFormRender<any>) {
    return (
      <>
        <CheckboxFormField
          form={form}
          name={'key'}
          label={<HeaderText title={title}>{subtitle}</HeaderText>}
          validations={validations}
        />

        <Button type="primary" onClick={form.handleSubmit}>
          {t('Update')}
        </Button>
      </>
    );
  }

  function onSubmitForm(newFormData: IFormData) {
    onSubmit(newFormData.key);
  }

  const classes = classNames('single-field-form', className);

  return <Form render={renderFormFields} onSubmit={onSubmitForm} className={classes} data={formData.current} />;
};

export default SingleCheckFieldForm;
